import { render, staticRenderFns } from "./PageStatistics.vue?vue&type=template&id=4e3cd73c&scoped=true"
import script from "./PageStatistics.vue?vue&type=script&lang=js"
export * from "./PageStatistics.vue?vue&type=script&lang=js"
import style0 from "./PageStatistics.vue?vue&type=style&index=0&id=4e3cd73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3cd73c",
  null
  
)

export default component.exports